<template>
    <div>
        <modal class="biz-ledger-detail" :display="modalStatus.bizLedgerDetail" @modalStatus="closeModal" >
            <h1>查看明細</h1>
            <div class="ledger-detail-wrap">
                <div class="content">
                    <div class="list">
                        <span class="title">記帳來源</span>
                        <span v-if="ledgerItem.isHouseGroup" class="info">：群組</span>
                        <span v-else class="info">：房源</span>
                    </div>
                    <div class="list">
                        <span v-if="ledgerItem.isHouseGroup" class="title">群組名稱</span>
                        <span v-else class="title">房源名稱</span>
                        <span class="info">：{{ledgerItem.name}}</span>
                    </div>
                    <div v-if="ledgerItem.ledgerType" class="list">
                        <span class="title">記帳類別</span>
                        <span class="info">：{{transType(ledgerItem.ledgerType)}}</span>
                    </div>
                    <div v-if="ledgerItem.ledgerItemType" class="list">
                        <span class="title">記帳項目</span>
                        <span class="info">：{{ledgerItemType(ledgerItem.ledgerItemType)}}</span>
                    </div>
                    <div v-if="ledgerItem.ledgerItemName" class="list">
                        <span class="title">備註</span>
                        <span class="info">：{{ledgerItem.ledgerItemName}}</span>
                    </div>
                    <div v-if="ledgerItem.amount" class="list">
                        <span class="title">成本</span>
                        <span class="info">：{{ledgerItem.amount}}</span>
                    </div>
                    <div v-if="ledgerItem.quote" class="list">
                        <span class="title">報價</span>
                        <span class="info">：{{ledgerItem.quote}}</span>
                    </div>
                    <div v-if="ledgerItem.recordingDate" class="list">
                        <span class="title">記帳時間</span>
                        <span class="info">：{{getFormatDateTime(ledgerItem.recordingDate)}}</span>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    props:{
        ledgerItem: {},
    },
    // mounted() {
    //     this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizLedgerDetail'})
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        // transPayWay: function (value) {
        //     if( value == 'WALLET' ){
        //         return '飛豬錢包'
        //     }else if( value == 'TRANSFER' ) {
        //         return '匯款轉帳'
        //     }else if( value == 'TASK_REFUND' ) {
        //         return '系統退款'
        //     }else if( value == 'DEPOSIT_FORFEIT' ) {
        //         return '訂金補償'
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.biz-ledger-detail{
        .modal-content{
            width: 488px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .refund-head{
                    display: flex;
                    align-items: center;
                    width: 424px;
                    height: 72px;
                    border-radius: 8px;
                    box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
                    border: solid 1px #f3f3f3;
                    background-color: #ffffff;
                    margin: 0 32px;
                    .title{
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #f3f3f3;
                        color: #a8a5a4;
                        height: 72px;
                    }
                    .amount{
                        padding: 0 20px;
                        font-size: 20px;
                        .red{
                            color: #ff9275;
                        }
                        .blue{
                            color: #3942b5;
                        }
                    }
                }
                .ledger-detail-wrap{
                    padding: 24px 52px;
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/ledgerDetail.vue